import { useState } from "react";

interface IFormInputProps {
  name: string;
  register: any;
  id?: string;
  type?: string;
  placeholder?: string;
  error?: string;
  defaultValue?: string;
  isPasswordInput?: boolean;
  autoComplete?: string;
  inputMode?: "text" | "numeric" | "tel" | "email";
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const FormInput = ({
  register,
  placeholder,
  error,
  name,
  type,
  isPasswordInput,
  ...rest
}: IFormInputProps) => {
  const [isShown, setIsShown] = useState(false);

  return (
    <>
      <div className="form-floating">
        <input
          {...register(name)}
          className={`form-control ${!!error && "border-danger"}`}
          placeholder={placeholder}
          type={isShown ? "text" : type}
          {...rest}
        />
        <label className="label" htmlFor={name}>
          {placeholder}
        </label>
        {isPasswordInput && (
          <i
            className={`las ${
              isShown ? "la-low-vision" : "la-eye"
            } password-icon text-muted`}
            onClick={() => setIsShown(!isShown)}
          ></i>
        )}
      </div>
      {!!error && (
        <div className="text-danger">
          <small>{error}</small>
        </div>
      )}
    </>
  );
};

export default FormInput;
